
(function ($, window, document) {
	var $win = $(window);
	var $doc = $(document);
	var $body = $(document.body);

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}

	function is_mobile() {
		return window_width() < 768;
	}

	// Called via callback var in Maps script URL.
	window.efront_init_map = function() {
		var mapStyles = [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		];

		$('#map').each(function(index, Element) {
			var center = $(this).data('center');
			var zoom = $(this).data('zoom');
			var icon = $(this).data('pin');

			var myOptions = {
				zoom: zoom,
				center: center,
				styles: mapStyles,
			};

			var map = new google.maps.Map(Element, myOptions);

			var marker = new google.maps.Marker({
				position: center,
				map: map,
				icon: {
					url: icon,
					//scaledSize: new google.maps.Size(80, 80),
				},
			});

			$win.on('resize', function (e) {
				map.setCenter(center);
			});
		});
	}

	/**
		* Helper function to scroll to section via CSS selector.
		*
		* @param {string} target_selector The CSS selector of the target element.
		* @param {number} duration        (Optional) The animation duration in ms. Default is 1000ms.
		*/
	function efront_scroll_to_section( target_selector, duration ) {
		var duration = duration !== undefined ? duration : 1000;
		var $target  = $( target_selector );

		if ( $target.length ) {
			var target_pos    = $target.offset().top + 1; // Sneaky +1px because modules have bottom border.
			var header_height = $('.header').outerHeight();

			// Set to 0 if (target position - header height) is a negative value.
			var scroll_to_pos = Math.max( 0, target_pos - header_height );

			$('html, body').animate({
				scrollTop: scroll_to_pos
			}, duration);
		}
	}

	function initSliders() {
		$('.js-slider-hero .slider__slides').slick({
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: false,
			fade: true,
			cssEase: 'linear'
		});

		var $sliders = $('.js-slider');

		// switch slider settings based on variable size

		$sliders.each(function(){
			var $this         = $(this);
			var $slick_slider = $this.find('.slider__slides');
			var caption_below = $this.hasClass('.slider--caption-below');
			var refresh_slider_position = function() {
				if ( $slick_slider.hasClass('slick-initialized') ) {
					$slick_slider.slick('setPosition');
				}
			};

			if ( $this.hasClass('slider--variable-size') ) {
				var slider_settings = {
					infinite: true,
					arrows: true,
					dots: false,
					centerMode: true,
					centerPadding: '20%',
					variableWidth: true,
					responsive: [
						{
							breakpoint: 767,
							settings: {
								centerMode: false,
								centerPadding: '20%',
								variableWidth: false,
								adaptiveHeight: true,
							}
						},
					],
				};
			}else{
				var slider_settings = {
					infinite: true,
					arrows: true,
					dots: false,
					adaptiveHeight: true,
				};
			}

			// Set prev/next arrows individually if they're within each slide.
			// Required because appendArrows attaches click handlers before cloning the slides.
			if ( $this.hasClass('slider--arrows-within') ) {
				slider_settings.prevArrow = $this.find('.slick-arrow.slick-prev');
				slider_settings.nextArrow = $this.find('.slick-arrow.slick-next');
			} else {
				slider_settings.appendArrows = $this.find('.slider__actions .slider__arrows');
			}

			$slick_slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
				var $js_slider = slick.$slider.closest('.slider--caption-below');

				if ( $js_slider.length ) {
					var $currentSlide = $(slick.$slides.get(currentSlide));
					var $caption_el   = $currentSlide.find(".slider__caption span");
					var caption       = $caption_el.length ? $caption_el.html() : '';

					$js_slider.find('.slider__actions .slider__caption span').html(caption);
				}
			});

			$slick_slider.on('init breakpoint', function() {
				window.requestAnimationFrame(function() {
					refresh_slider_position();
				});
			});

			$slick_slider.slick(slider_settings);

			$slick_slider.find('img').on('load', refresh_slider_position);

			$slick_slider.find('img').each(function() {
				if ( this.complete ) {
					refresh_slider_position();
				}
			});
		});

		var $card_sliders = $('.js-slider-cards');

		$card_sliders.each(function() {
			var $this           = $(this);
			var $card_carousel  = $this.find('.slider__slides');

			$card_carousel.on('breakpoint init setPosition', function(event, slick, breakpoint) {
				// Refresh matchHeight on Slick init, breakpoint change, or when it recalculates its position (after orientation change etc).
				refresh_match_height();
			});

			$card_carousel.slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				appendArrows: $this.find('.slider__actions .slider__arrows'),
				arrows: true,
				dots: false,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
						}
					},
				],
			});
		});
	}

	function loadAnimations() {
		$('body').addClass('is-not-animated');

		if ( ! $('.section-animated').length || hasSeenAcknowledgement() ) {
			return;
		}

		window.requestAnimationFrame(function() {
			window.requestAnimationFrame(function() {
				$('body').addClass('show-aoc');
			});
		});
	}

	function hasSeenAcknowledgement() {
		if ( typeof Cookies !== 'undefined' && Cookies.get( 'efront_seen_aoc' ) === 'yes' ) {
			return true;
		}

		try {
			return window.localStorage.getItem( 'efront_seen_aoc' ) === 'yes';
		} catch (e) {
			return false;
		}
	}

	function markAcknowledgementSeen() {
		if ( typeof Cookies !== 'undefined' ) {
			Cookies.set( 'efront_seen_aoc', 'yes', { expires: 31536000 } );
		}

		try {
			window.localStorage.setItem( 'efront_seen_aoc', 'yes' );
		} catch (e) {
			// Ignore storage failures.
		}
	}

	function attachClickHandlers() {
		$doc.on('click', '.js-remove-animation', function(e) {
			e.preventDefault();

			$('body').addClass('is-not-animated');

			if ( $body.hasClass('show-aoc') ) {
				markAcknowledgementSeen();
				$body.removeClass('show-aoc');
			}
		})

		// scroll to anchor point from submenu
		$doc.on('click', '.nav--submenu a', function(e) {
			e.preventDefault();

			var $this       = $(this);
			var target_hash = $this.attr('href');

			$this.closest('.nav--submenu').find('.is-active').removeClass('is-active');
			$this.addClass('is-active');

			efront_scroll_to_section( target_hash );
		});

		// Scroll to top link in footer.
		$doc.on('click', '.js-scroll-to-top', function(e) {
			e.preventDefault();

			// Scroll to body, i.e. top of page.
			efront_scroll_to_section( 'body' );
		});

		$doc.on('click', function (e) {
			const $dropdowns = $('.dropdown')

			$dropdowns.each(function (index, dropdown) {
				if ($(this).hasClass('is-active')) {
					if (e.target == $('.header')[0] || e.target == $('.header__inner')[0]) {
						e.stopPropagation();
						$(this).removeClass('is-active');
					}

					if (e.target == $('.dropdown')[0]) {
						e.stopPropagation();
						$(this).removeClass('is-active');
					}
				}
			});
		})

		$doc.on('click', '.js-dropdown, a[href="#book-appointment"]', function(e) {
			e.preventDefault();

			$('.dropdown').toggleClass('is-active');
			$('.header__mobile-nav').removeClass('is-active');
			$('.js-burger-btn').removeClass('is-active');
		});

		$doc.on('click', '.js-burger-btn', function(e) {
			e.preventDefault();

			$(this).toggleClass('is-active');
			$('.header__mobile-nav').toggleClass('is-active');
			$('.dropdown').removeClass('is-active')
		});
	}

	function refresh_match_height() {
		$.fn.matchHeight._applyDataApi();
	}

	$(document).on('gform_confirmation_loaded', function(event, formId){
	    // code to be trigger when confirmation page is loaded
	    $body.addClass('gravity_confirmation');
	});


	$(window).on('scroll load', function (e) {
		const $header = $('.header');
		const $pageTop = $(window).scrollTop();

		if ($pageTop > 0) {
			$header.addClass('is-fixed')
		} else {
			$header.removeClass('is-fixed')
		}
	})

	$(window).on('load', function () {
		initSliders();
	});

	// On dom ready.
	$(function(){
		attachClickHandlers();
		loadAnimations();
	});
})(jQuery, window, document);
